import React, { useEffect, useState } from 'react'
import {
    useMsal,
    useAccount,
    useIsAuthenticated,
} from '@azure/msal-react'
import {  useLocation } from 'react-router-dom'
import { loginRequest } from 'authConfig'
import { getFirstTwoWords, getFirstLetterOfEachWord } from 'helper/regex'
import Loading from 'components/Loading'
import { ModalWarning } from 'components/Modals/ModalWarning'
import { RootReducerState } from 'types/global'
import { AuthenticationReducer } from 'types/autentication'
import UserServices from 'services/User'
import { Dispatch } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { AuthenticationAction } from 'types/autentication'
import AuthenticationActions from 'actions/Authentication'
import { userProfiles } from 'types/user'
import { HeaderToShow } from './HeaderToShow'
import { NavBarAuthenticatedComponent } from './NavBarAuthenticated'

/**
 * Componente de barra de navegação principal
 * @author Qualidor
 */
const NavBar: React.FC<any> = ({ children, ...rest }) => {

    const { pathname } = useLocation()
    const { instance, accounts } = useMsal()
    const account = useAccount(accounts[0])
    const isAuthenticated = useIsAuthenticated()
    const [currentUser, setCurrentUser] = useState<string>()
    const [initialsUser, setInitialsUser] = useState<string>()
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false)
    const [currentProfile, setCurrentProfile] = useState<string>()
    const [profile, setProfile] = useState<string>()
    const authenticationDispatch: Dispatch<AuthenticationAction> = useDispatch<Dispatch<AuthenticationAction>>()

    const authenticationSelector: AuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )

    const handleTabClosing = () => {
        setIsOpenModal(false)
        instance.loginRedirect(loginRequest).catch((e) => {
            sessionStorage.clear()
            console.log(e)
        })
    }

    const handleConfirmModal = () => {
        setIsOpenModal(false)
    }

    const isCypressAuthenticated = () => {
        try {
            return sessionStorage.getItem('test.cypress.authenticated') === 'true';
        } catch {
            return false;
        }
    };




    const sessionCypressProfile = sessionStorage.getItem(
        'test.cypress.profile'
    )
    /**
     * Funcao para redirecionamento para tela de logout do Azure AD
     */
    const handleLogout = () => {
        sessionStorage.clear()
        instance.logoutRedirect({
            postLogoutRedirectUri: '/'
        })
    }
    useEffect(() => {
        if (isAuthenticated) {
            setCurrentUser(getFirstTwoWords(account.name))
            setInitialsUser(
                getFirstLetterOfEachWord(getFirstTwoWords(account.name))
            )

        } else if (isCypressAuthenticated()) {
            setCurrentUser('Cypress')
            setInitialsUser('C Y')
        }
    }, [isAuthenticated])

    useEffect(() => {
        if (isAuthenticated) {
            let userProfile = userProfiles.find((userProfile) => userProfile.id === currentProfile)
            if (userProfile) {
                let currentLocations = authenticationSelector.dataJwt.locations
                let strProfile = `Perfil: ${userProfile.title}`
                let strCurrentLocations = (
                    currentProfile === 'admin' ||
                    currentProfile === 'corporate_quality_management' ||
                    currentProfile === 'corporate_quality_board') ?
                    `Todas`
                    :
                    (currentLocations && currentLocations.length > 0 ? currentLocations.map((loc) => {
                        let s = `\n${loc.name}`
                        if (currentProfile === 'location_manager' && loc.sectors && loc.sectors.length > 0)
                            s += loc.sectors.map((sec) => `\n\t${sec.name}`).join(' ')
                        return s
                    }).join(' ') : 'Nenhuma')

                strProfile += `\n\nUnidades: ${strCurrentLocations}`

                setProfile(strProfile)
            }
        }
    }, [currentProfile])

    useEffect(() => {
        if (isAuthenticated && !authenticationSelector.azureAccessTokenExpired) {
            const azureToken = sessionStorage.getItem('AZURE_AD_ACCESS_TOKEN')

            if (authenticationSelector.dataJwt) {
                setCurrentProfile(authenticationSelector.dataJwt.profile)
            } else if (azureToken) {
                UserServices.getAuthenticationUser(azureToken).then(async (response) => {
                    let json = await response.json()
                    if (response && json.data && json.data) {
                        AuthenticationActions.showHeader(authenticationDispatch, true)
                        AuthenticationActions.setDataJwt(authenticationDispatch, json.data)
                        sessionStorage.setItem('JWT_TOKEN', json.data.tokenJwt)
                    }
                    if (json.message && !authenticationSelector.jwtAccessTokenExpired)
                        AuthenticationActions.setTokenJwtExpired(authenticationDispatch, true, json)
                }).catch((err) => {
                    if (err && !authenticationSelector.jwtAccessTokenExpired)
                        AuthenticationActions.setTokenJwtExpired(authenticationDispatch, true, err)
                })
            }
        }

    }, [authenticationSelector.dataJwt])

    useEffect(() => {
        if (isCypressAuthenticated()) 
            setCurrentProfile(sessionCypressProfile)
    }, [])

    /**
     * Elemento de menu principal externo
     */
    const NavBarAuthenticated = () => {
        return <NavBarAuthenticatedComponent
            currentProfile={currentProfile}
            profile={profile}
            currentUser={currentUser}
            handleLogout={handleLogout}
            initialsUser={initialsUser}
        />
    }


    return (
        <div id={'navbar'}>
            <Loading />
            <ModalWarning
                isOpen={isOpenModal}
                handleConfirmModal={handleConfirmModal}
                handleCloseModal={handleTabClosing}
            />
            <HeaderToShow
                    authenticationSelector={authenticationSelector}
                    NavBarAuthenticated={NavBarAuthenticated}
                    sessionCypressAuthenticated={isCypressAuthenticated()? "true" : "false"}
                    pathname={pathname}
                />
        </div>
    )
}

export default NavBar


